import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../context/AppContext';
import FieldGroup from '../FieldGroup';
import SectionTitle from '../SectionTitle';
import Dropdown from '../Dropdown';
import { categories } from '../../data/categories';

const complexityOptions = [
  { value: 'simple', label: 'Simple - Basic functionality' },
  { value: 'medium', label: 'Medium - Moderate features' },
  { value: 'complex', label: 'Complex - Advanced features' },
];

const categoryOptions = categories.map(cat => ({ value: cat.id, label: cat.label }));

function Step2Configuration() {
  const { projectDraft, dispatch } = useAppContext();
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [showOtherSubCategory, setShowOtherSubCategory] = useState(false);

  useEffect(() => {
    if (projectDraft.category) {
      const selectedCat = categories.find(c => c.id === projectDraft.category);
      const options = selectedCat ? selectedCat.subcategories.map(sc => ({ value: sc, label: sc })) : [];
      setSubCategoryOptions(options);
    } else {
      setSubCategoryOptions([]);
    }
  }, [projectDraft.category]);

  useEffect(() => {
    setShowOtherSubCategory(projectDraft.subCategory === 'Other');
  }, [projectDraft.subCategory]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let payload = { [name]: value };
    
    if (name === 'category') {
      payload.subCategory = '';
    }
    
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload });
  };

  return (
    <div className="space-y-6">
      <SectionTitle title="Project Configuration" subtitle="Set up the technical foundation of your project." />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FieldGroup label="Category">
          <Dropdown
            options={categoryOptions}
            name="category"
            value={projectDraft.category || ''}
            onChange={handleChange}
            placeholder="Select a category"
          />
        </FieldGroup>
        
        <FieldGroup label="Project Complexity">
          <Dropdown
            options={complexityOptions}
            name="complexity"
            value={projectDraft.complexity || ''}
            onChange={handleChange}
            placeholder="Select complexity"
          />
        </FieldGroup>
      </div>

      {projectDraft.category && (
        <FieldGroup label="Sub-category">
          <Dropdown
            options={subCategoryOptions}
            name="subCategory"
            value={projectDraft.subCategory || ''}
            onChange={handleChange}
            placeholder="Select a sub-category"
          />
        </FieldGroup>
      )}

      {showOtherSubCategory && (
        <FieldGroup label="Please specify 'Other' sub-category">
          <input
            type="text"
            name="otherSubCategory"
            value={projectDraft.otherSubCategory || ''}
            onChange={handleChange}
            className="form-input"
            placeholder="Enter custom sub-category"
          />
        </FieldGroup>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FieldGroup label="Framework">
          <input 
            type="text" 
            value="React (Vite)" 
            readOnly 
            className="form-input bg-gray-50" 
          />
        </FieldGroup>
        
        <FieldGroup label="Styling">
          <input 
            type="text" 
            value="TailwindCSS" 
            readOnly 
            className="form-input bg-gray-50" 
          />
        </FieldGroup>
      </div>
    </div>
  );
}

export default Step2Configuration;